import { render, staticRenderFns } from "./VideoContentItem.vue?vue&type=template&id=e637f068"
import script from "./VideoContentItem.vue?vue&type=script&lang=js"
export * from "./VideoContentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports